const DownloadTemplateIcon = ({ className = "", onClick = null }) => {
  return (
    <svg
      viewBox="0 0 500 500"
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M404.63,348.33v73.84c0,7.07-5.75,12.82-12.83,12.82-.88,0-1.78-.09-2.64-.27l-.47-.1H108.2c-7.08,0-12.83-5.75-12.83-12.82v-73.84c0-7.07,5.75-12.82,12.83-12.82s12.82,5.75,12.82,12.82v61.02h257.95v-60.64c0-7.07,5.75-12.82,12.82-12.82s12.83,5.75,12.83,12.82Z"
      />
      <path
        d="M356.32,230.93l-98.56,96.7-.29.22-.16.22c-.24.23-.48.44-.72.64l-.14.1c-.28.23-.56.43-.86.63l-.18.11c-.29.19-.59.37-.9.53-.02.02-.04.03-.06.04l-.12.06c-.32.16-.63.31-.98.45t-.02,0l-.12.05c-.34.13-.69.25-1.02.35l-.13.04c-.35.1-.7.19-1.03.25l-.14.03c-.39.07-.75.12-1.04.15h-.16c-.86.08-1.56.08-2.34,0h-.18c-.35-.05-.71-.1-1.05-.17l-.16-.03c-.35-.08-.71-.16-1.08-.27-.03,0-.06-.02-.09-.03-.34-.1-.69-.23-1.03-.37l-.14-.06c-.32-.13-.66-.29-1-.47l-.15-.08c-.31-.16-.63-.36-.95-.56l-.15-.09c-.32-.22-.63-.45-.96-.71l-.08-.08c-.31-.26-.61-.54-.9-.84l-95.85-96.96c-4.97-5.03-4.93-13.17.1-18.15,5.03-4.96,13.17-4.92,18.14.11l73.9,74.75V77.82c0-7.07,5.75-12.82,12.82-12.82s12.82,5.75,12.82,12.82v210.36l77.02-75.56c2.44-2.4,5.68-3.69,9.11-3.67,3.42.03,6.63,1.39,9.03,3.84,4.95,5.05,4.88,13.19-.17,18.15Z"
      />
    </svg>
  );
};
  
export default DownloadTemplateIcon;
